import React from "react";
import {useTranslation} from "react-i18next";
import {capitalizeFirstLetter} from "../../utilities/functions";

export default function Denied() {
    const {t} = useTranslation();
    return (
        <div style={{
            margin: "auto",
            position: "relative",
            textAlign: "center",
            top: "50%",
            width: "20%"
        }}>
            <p><b>Forbidden (403)</b></p>
            <p>{capitalizeFirstLetter(t('access_denied'))}</p>
        </div>
    )
}